import { render, staticRenderFns } from "./BookEditModal.vue?vue&type=template&id=3aee7143&"
import script from "./BookEditModal.vue?vue&type=script&lang=js&"
export * from "./BookEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports